import { Replace } from 'lucide-react';

import { Button } from 'shadcn/components/ui/Button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from 'shadcn/components/ui/Dialog';

/**
 * Confirmation dialog before updating substitutions on a batch.
 * @param {object} props
 * @param {boolean} props.open - Whether the dialog is open
 * @param {(open: boolean) => void} props.onOpenChange - Dialog open/close handler
 * @param {() => void} props.onConfirm - Called when the operator confirms
 * @returns {JSX.Element}
 */
export function ApplySubstitutionsConfirmDialog({ onConfirm, onOpenChange, open }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <Replace className="h-5 w-5" aria-hidden="true" />
                        Update Substitutions?
                    </DialogTitle>
                    <DialogDescription>
                        Applies or removes substitution rules that were enabled or disabled after this batch was
                        printed, for eligible orders in the batch.
                    </DialogDescription>
                </DialogHeader>
                <ul className="list-disc space-y-2 pl-5 text-sm text-foreground">
                    <li>Skips shipments that are already Packed</li>
                </ul>
                <DialogFooter className="gap-2">
                    <Button variant="outline" onClick={() => onOpenChange(false)}>
                        Cancel
                    </Button>
                    <Button onClick={onConfirm}>Apply Substitutions</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

ApplySubstitutionsConfirmDialog.displayName = 'ApplySubstitutionsConfirmDialog';
